import axios from 'axios';

import store from 'utils/Store';
import { SET_ERROR_STATE, SET_MAINTENANCE } from 'redux/actions/types';
import packageInfo from '../../package.json';

const { TIMEOUT } = process.env;

export const setErrorState = val => dispatch =>
  dispatch({
    type: SET_ERROR_STATE,
    payload: val,
  });

export const setMaintenance = maintenance => dispatch => {
  dispatch({
    type: SET_MAINTENANCE,
    payload: maintenance,
  });
};
class ApiService {
  static INSTANCE;

  static getInstance = () => {
    if (!ApiService.INSTANCE) ApiService.INSTANCE = new ApiService();
    return ApiService.INSTANCE;
  };

  constructor() {
    this.billerService = axios.create({
      baseURL: process.env.ANTEIKU_URL,
      timeout: TIMEOUT,
      headers: {
        'X-Client-Version': packageInfo.version,
      },
    });
    this.mixpanelService = axios.create({
      baseURL: process.env.NEUTRINO_URL,
      timeout: TIMEOUT,
      headers: {
        'X-Mixpanel-Project': 'dana_standalone',
      },
    });

    this.billerService.interceptors.response.use(this.onSuccess, this.onError);
  }

  onSuccess = response => response;

  onError = err => {
    const {
      response: {
        status,
        data: { message },
      },
    } = err;
    if (status === 401) {
      store.dispatch(setErrorState(true));
    } else if (
      status === 503 &&
      (message.title === 'ALL_BILLERS_UNDER_MAINTENANCE' ||
        message.title === 'SERVICE_UNDER_MAINTENANCE')
    ) {
      const maintenance = {
        isMaintenance: true,
        description: {
          ...message.additional_info.maintenance_remarks,
        },
      };
      store.dispatch(setMaintenance(maintenance));
    }
    return Promise.reject(err);
  };

  setBearer = token => {
    this.billerService.defaults.headers.common = {
      Authorization: `Bearer ${token}`,
    };
  };
}

export default ApiService;
